<template>
  <div class="item-master-header">
    <div class="item-master-header__thumb">
      <img :src="thumbnailUrl" alt="Item thumbnail" />
    </div>
    <div class="item-master-header__content">
      <div class="item-master-header__title-row">
        <h2 class="item-master-header__title">{{ title }}</h2>
        <div class="item-master-header__status" :class="statusClass">
          <span class="item-master-header__status-dot"></span>
          <span>{{ statusLabel }}</span>
        </div>
      </div>
      <p class="item-master-header__subtitle">{{ subtitle }}</p>
      <div class="item-master-header__meta">
        <span class="item-master-header__chip">{{ code }}</span>
        <span class="item-master-header__chip item-master-header__chip--type">
          {{ typeLabel }}
        </span>
        <span v-if="category" class="item-master-header__chip item-master-header__chip--category">
          {{ category }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemMasterHeader',
  props: {
    materialMaster: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: String,
      default: 'material'
    }
  },
  computed: {
    title () {
      const mm = this.materialMaster || {}
      return mm.material_name || '--'
    },
    subtitle () {
      const mm = this.materialMaster || {}
      return mm.material_description || 'No description available'
    },
    code () {
      const mm = this.materialMaster || {}
      return mm.custom_material_id || '--'
    },
    typeLabel () {
      const mm = this.materialMaster || {}
      if (this.view === 'resource') {
        return mm.resource_type_value?.name || 'RESOURCE'
      }
      return mm.material_type_value?.name || 'MATERIAL'
    },
    category () {
      const mm = this.materialMaster || {}
      return mm.material_group_details?.name || ''
    },
    thumbnailUrl () {
      const mm = this.materialMaster || {}
      return mm.thumbnailUrl || require('@/assets/images/icons/light-file-icon.svg')
    },
    statusLabel () {
      const mm = this.materialMaster || {}
      const map = {
        1: 'Active',
        2: 'Obsolete',
        3: 'Released',
        4: 'Locked'
      }
      return map[mm.status] || 'Active'
    },
    statusClass () {
      const mm = this.materialMaster || {}
      const map = {
        1: 'status-active',
        2: 'status-obsolete',
        3: 'status-released',
        4: 'status-locked'
      }
      return map[mm.status] || 'status-active'
    }
  }
}
</script>

<style lang="scss" scoped>
.item-master-header {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 5px;
  align-items: center;

  &__thumb {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    background: #f8fafc;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__title-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  &__title {
    margin: 0;
    font-size: var(--text-l);
    font-weight: 500;
    color: #111827;
  }

  &__status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: var(--text-xs2);
    font-weight: 500;
    color: #16a34a;
  }

  &__status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }

  &__subtitle {
    margin: 0;
    color: #64748b;
    font-size: var(--text-xs1);
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__chip {
    background: #f3f4f6;
    color: #111827;
    font-size: var(--text-xs1);
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  &__chip--type {
    background: #e0ecff;
    color: #1d4ed8;
  }

  &__chip--category {
    background: #ede9fe;
    color: #6d28d9;
  }
}

.status-active {
  color: #16a34a;
}

.status-obsolete {
  color: #6b7280;
}

.status-released {
  color: #2563eb;
}

.status-locked {
  color: #dc2626;
}

@media (max-width: 640px) {
  .item-master-header {
    grid-template-columns: 1fr;

    &__thumb {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
